import { EMPTY_CELL_STATE } from '@/creditflowresearch/ui/common/constants';
import DealLeads from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/DealLeads';
import { LEAD_ROLE } from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/leadRoles';
import type { IDealLead } from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/types';

import styles from '@/creditflowresearch/ui/components/bondscreener/Cells/cells.module.scss';

export type TLeadField = 'structuringLeads' | 'leftLead' | 'activeLeads' | 'jointLeads' | 'passiveLeads'
  | 'bookAndDelivery' | 'coManagers' | 'coordinatingManagers' | 'diCoordinators';

/**
 * Lead columns of the corporate and ABS screeners, in the order the tooltip lists them.
 */
const LEAD_FIELDS: readonly { field: TLeadField, role: string }[] = [
  { field: 'structuringLeads', role: LEAD_ROLE.structuring },
  { field: 'leftLead', role: LEAD_ROLE.left },
  { field: 'activeLeads', role: LEAD_ROLE.active },
  { field: 'jointLeads', role: LEAD_ROLE.joint },
  { field: 'passiveLeads', role: LEAD_ROLE.passive },
  { field: 'bookAndDelivery', role: LEAD_ROLE.billingDelivering },
  { field: 'coManagers', role: LEAD_ROLE.coManager },
  { field: 'coordinatingManagers', role: LEAD_ROLE.coordinatingManager },
  { field: 'diCoordinators', role: LEAD_ROLE.diCoordinator },
];

interface ILeadsCellProps {
  row: Partial<Record<TLeadField, IDealLead[] | null>>,
  field: TLeadField,
}

/**
 * One lead column shows the banks of its own role; its tooltip shows every lead column the row has.
 */
const LeadsCell = ({ row, field }: ILeadsCellProps) => {
  if (!row[field]?.length) {
    return EMPTY_CELL_STATE;
  }

  const groups = LEAD_FIELDS.map(({ field: leadField, role }) => ({ role, leads: row[leadField] }));
  const cellRole = LEAD_FIELDS.find((lead) => lead.field === field)?.role;

  return (
    <span className={ styles.leadsContent }>
      <DealLeads groups={ groups } inlineRoles={ cellRole ? [cellRole] : [] } limit={ 3 } target="_blank" />
    </span>
  );
};

export default LeadsCell;
